import { NgModule } from "@angular/core";
import { RaskCommonModule } from "../../../common/rask-common.module";
import { RebusMessagesComponent } from "./rebus-messages/rebus-messages.component";
import { RebusComponent } from "./rebus.component";
import { RebusService } from "./rebus.service";

@NgModule({
    imports: [
        RaskCommonModule,
        RebusComponent,
        RebusMessagesComponent
    ],
    providers: [RebusService]
})
export class RebusModule { }
